import firebaseInstance from "../../../util/firebase";

export default {
  deleteTaskPhoto: (state, item) => {
    firebaseInstance
      .database()
      .ref(
        "projectsFull/" +
          item.projectid +
          "/moduleColumns/" +
          item.section +
          "/" +
          item.index +
          "/taskImage"
      )
      .set("")
      .then(() => {
        console.log("Task image path removed");
        // var object = {url: null}
        // state.commit('SAVE_PROFILE_IMAGE', object)
      })
      .catch(error => {
        console.log(error, "Error deleting task image");
      });
  },
  saveTaskImage: (state, item) => {
    var randomNumber = Math.floor(Math.random() * 100000000000000000);
    var extension = item.file.name;
    var fileName = randomNumber.toString() + extension;
    extension = extension.substr(extension.lastIndexOf("."), extension.length);
    console.log("item", randomNumber, extension);

    firebaseInstance
      .storage()
      .ref("tasksImage/" + fileName)
      .put(item.file)
      .then(snapshot => {
        console.log("Uploaded a blob or file!", snapshot);
        firebaseInstance
          .storage()
          .ref("tasksImage/" + fileName)
          .getDownloadURL()
          .then(url => {
            console.log("url", url);
            firebaseInstance
              .database()
              .ref(
                "projectsFull/" +
                  item.projectid +
                  "/moduleColumns/" +
                  item.section +
                  "/" +
                  item.index +
                  "/taskImage"
              )
              .set(url)
              .then(() => {
                console.log("Task image path saved");
                // var object = {url: url}
                // state.commit('SAVE_PROFILE_IMAGE', object)
              })
              .catch(error => {
                console.log(error, "Error saving path to profile image");
              });
          })
          .catch(error => {
            console.log(error, "Error getting task image");
          });
      });
  },
  addNewDefaultTask: (state, item) => {
    console.log("addNewDefaultTask", item);
    firebaseInstance
      .database()
      .ref("companies/" + item.companyid + "/companyTasks")
      .once("value", snap => {
        var companyTasks = snap.val();
        if (companyTasks) {
        } else {
          companyTasks = [];
        }
        companyTasks.push({
          name: "New Task",
          taskType: "hourlyElements",
          useDefaultTask: false
        });
        firebaseInstance
          .database()
          .ref("companies/" + item.companyid + "/companyTasks")
          .update(companyTasks, () => {
            console.log("saved companyTasks");
          })
          .catch(error => {
            console.log("Error saving companyTasks", error);
          });
      })
      .catch(error => {
        console.log("Error getting modules 1", error);
      });
  }
};
